import axios from "axios";
import { getAccessToken, removeAccessToken, removeRefreshToken } from "./cookies";
import { Message } from "element-ui";
import router from "@/router";
import i18n from '../i18n/i18n';
// 添加响应拦截器
const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 60000
});
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    config.headers['Platform'] = 5;
    config.headers['timeZone'] = new Date().getTimezoneOffset() / 60;
    if (getAccessToken()) {
        config.headers['Access-Token'] = getAccessToken();         //携带token
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    const data = response.data;
    if (data.code === 0 || typeof data.code === 'undefined') {
        return Promise.resolve(data);
    } else if (data.code === 1008) {
        return Promise.resolve(data);
    } else {
        Message({
            message: i18n.t('notification.' + data.code),
            type: "error"
        })
        if (data.code === 999 || data.code === 1000) {
            router.replace({ name: 'Login' })
            removeAccessToken();
            removeRefreshToken();
        }
        return Promise.reject(data);
    }
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    console.log('========', error);

    const errorData = error.request.response && JSON.parse(error.request.response);
    if (errorData.message) {
        Message({
            message: errorData.message,
            type: "error"
        })
    }
    // 如果token失效
    if (errorData.code === 999 || errorData.code === 1000) {
        router.replace({ name: 'Login' })
        removeAccessToken();
        removeRefreshToken();
    }
    return Promise.reject(errorData);
});

export default instance;


// WEBPACK FOOTER //
// ./src/utils/request.js